import React, { useContext, useEffect, useState } from "react";
import Header3 from "../../components/Header3";
import { Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../AxiosInstance";
import { ChatState } from "../../context/ChatProvider";
import toast from "react-hot-toast";
import { LanguageContext } from "../../context/LanguageContext";
import { BsQuestionCircleFill } from "react-icons/bs";
import { fromZonedTime } from "date-fns-tz";
import { ChevronDown } from "lucide-react";

const SilentReading = () => {
  const navigate = useNavigate();
  const { lg } = useContext(LanguageContext);
  const { user } = ChatState();
  const [show, setShow] = useState(false); // For signup modal
  const handleClose = () => {
    setShow(false); // Close signup modal
    navigate("/leading"); // Navigate to home page
  };
  const [eventLocation, setEventLocation] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  const [wShow, setWShow] = useState(false); // For signup modal

  const handleCloseW = () => {
    setWShow(false);
  };
  const handleShowW = () => {
    setWShow(true); // Open  modal
  };

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // 0-based (Jan = 0)
  const currentYear = currentDate.getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear + i);

  // const DateSelector = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [weekday, setWeekday] = useState("");

  const [selectedDays, setSelectedDays] = useState("");

  /**
   * Get available months for a given year.
   */
  const getAvailableMonths = (selectedYear) => {
    if (parseInt(selectedYear) === currentYear) {
      // If it's the current year, show only future months (including current month)
      return months.slice(currentMonth);
    } else {
      // For future years, show all months
      return months;
    }
  };

  const availableMonths = getAvailableMonths(selectedYear);

  // Automatically update day when date, month, and year are selected
  useEffect(() => {
    if (selectedDate && selectedMonth !== "" && selectedYear) {
      const monthIndex = months.indexOf(selectedMonth);
      const date = new Date(selectedYear, monthIndex, selectedDate);
      setSelectedDays(daysOfWeek[date.getDay()]); // Auto-select day
    }
  }, [selectedDate, selectedMonth, selectedYear]);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [eventAddress, setEventAddress] = useState("");
  const [visibility, setVisibility] = useState("");
  const [eventDetails, setEventDetails] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestionsCity, setSuggestionsCity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCityObj, setSelectedCityObj] = useState(null);
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const handleInputChangeCity = async (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim() !== "") {
      try {
        const response = await axios.get(
          `/api/v1/books/books/searchCity?query=${encodeURIComponent(value)}`
        );

        if (response.data.success && Array.isArray(response.data.data)) {
          setSuggestionsCity(response.data.data); // Show city suggestions
        } else {
          setSuggestionsCity([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestionsCity([]);
      }
    } else {
      setSuggestionsCity([]); // Reset suggestions when input is empty
    }
  };

  const handleSuggestionClick = (cityObj) => {
    console.log("Selected city:", cityObj.city);
    console.log("Selected country:", cityObj.country);

    setCity(cityObj.city); // Set the selected city
    setCountry(cityObj.country); // Set the selected country
    setSearchQuery(`${cityObj.city}, ${cityObj.country}`); // Set searchQuery to both city and country
    setSelectedCityObj(cityObj);
    setSuggestionsCity([]); // Hide suggestions after selection
  };

  const [ageRanges, setAgeRanges] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedMaxAge, setSelectedMaxAge] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [loadingMen, setLoadingMen] = useState(false);
  const [error, setError] = useState(null);
  const [book, setBook] = useState({});

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const handleMaxChange = (e) => {
    setMaxValue(e.target.value);
  };
  const handleMinChange = (e) => {
    setMinValue(Number(e.target.value));
  };

  const { id } = useParams();
  const joinedAge = `${selectedAge}-${selectedMaxAge}`; // e.g. "10-16"

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/v1/books/${id}`)
        .then((res) => {
          const data = res.data;
          setBook(data); // If needed

          // setSelectedAge(data.age);
          const [minAge, maxAge] = data.age?.split("-") || ["", ""];
          setSelectedAge(minAge);
          setSelectedMaxAge(maxAge);
          setSelectedLanguage(data.language);

          setEventDetails(data.description);
          setSelectedMonth(data.dateInfo?.month || ""); // already working
          setSelectedYear(data.dateInfo?.year || ""); // already working
          setSelectedDays(data.dateInfo?.dayName || ""); // weekday (optional)
          setSelectedDate(
            data.dateInfo?.day?.toString().padStart(2, "0") || ""
          );
          setEventTime(
            data.timeTrack?.minutes?.toString().padStart(2, "0") || ""
          );
          setVisibility(
            data.timeTrack?.seconds?.toString().padStart(2, "0") || ""
          );
          setMaxValue(data.maxAttendee || "");
          setMinValue(data.minAttendee || "");

          setSearchQuery(data.city);

          setSelectedCityObj({
            city: data.city,
            country: data.country,
            latitude: data.lati,
            longitude: data.langi,
          });
          setEventLocation(data.location?.name || "");
          setEventAddress(data.location?.address || "");

          // setModalData({ link: data.image, showImage: true });
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch age ranges
        const ageResponse = await axios.get(`/api/v1/stores/age`);
        setAgeRanges(ageResponse.data.data);

        // Fetch languages
        const langResponse = await axios.get(`/api/v1/stores/lang`);
        setLanguages(langResponse.data.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // Automatically update day when date, month, and year are selected
  useEffect(() => {
    if (selectedDate && selectedMonth && selectedYear) {
      const monthIndex = months.indexOf(selectedMonth);
      const selectedFullDate = new Date(selectedYear, monthIndex, selectedDate);

      const today = new Date();
      today.setHours(0, 0, 0, 0); // remove time component

      // ✅ Prevent past dates
      if (selectedFullDate < today) {
        toast.error("You cannot select a past date!");
        setSelectedDate("");
        setSelectedMonth("");
        setSelectedYear("");
        setSelectedDays("");
        return;
      }

      setSelectedDays(daysOfWeek[selectedFullDate.getDay()]);
    }
  }, [selectedDate, selectedMonth, selectedYear]);
  const handleCreateEvent = async () => {
    const monthMap = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const paddedMonth = monthMap[selectedMonth] ?? "01"; // Convert month name to 2-digit format
    const paddedDate = selectedDate.padStart(2, "0");
    const paddedSeconds = visibility.padStart(2, "0"); // assuming visibility is seconds
    const dateTimeStr = `${selectedYear}-${paddedMonth}-${paddedDate}T${eventTime}:${visibility}:00`; // e.g. "2025-07-11T18:00:00"
    const organizerTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const eventTimeInOrganizerZone = fromZonedTime(
      dateTimeStr,
      organizerTimeZone
    );
    try {
      // 1. Validate and build payload
      const payload = {
        title: "",
        name: "Silent Reading",
        author: "",
        genre: "",
        globalTime: eventTimeInOrganizerZone.toISOString(), // accurate UTC
        timeZone: organizerTimeZone,
        age: joinedAge,
        language: selectedLanguage,
        type: "In-person",
        description: eventDetails,
        maxAttendee: maxValue,
        minAttendee: minValue,
        userId: user?._id, // You need to get this from auth
        dateInfo: {
          day: selectedDate,
          month: selectedMonth,
          year: selectedYear,
          dayName: selectedDays,
        },
        timeTrack: {
          minutes: eventTime,
          seconds: visibility,
        },
        email: user?.email,
        city: selectedCityObj?.city, // ✅ Use from selectedCityObj
        country: selectedCityObj?.country, // ✅ Optional if needed
        lati: selectedCityObj?.latitude, // ✅ Accurate location
        langi: selectedCityObj?.longitude,
        image: "",
        ...("In-person" === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0, // ✅ longitude first
              selectedCityObj?.latitude ?? 0, // ✅ then latitude
            ],
          },
        }),
      };

      // 2. Check for any missing required fields
      const requiredFields = {
        Age: payload.age,
        Language: payload.language,
        "Event Type": payload.type,
        Description: payload.description,
        "Date (day)": payload.dateInfo.day,
        "Date (month)": payload.dateInfo.month,
        "Date (year)": payload.dateInfo.year,
        "Time (minutes)": payload.timeTrack.minutes,
        "Time (hours)": payload.timeTrack.seconds,
        minAttendee: minValue,
        maxAttendee: maxValue,
        ...(payload.type === "In-person" && {
          "Location Name": payload.location?.name,
          "Location Address": payload.location?.address,
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // 3. Make API call with Axios
      const response = await axios.post("/api/v1/books/addbooks", payload, {
        headers: {
          "Content-Type": "application/json",
          // Add if using authentication:
          // 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      });

      // 4. Handle success
      toast.success("Book event created successfully!");
      console.log("Created book:", response.data);
      handleShow(true);
      setSelectedDate("");
      setSelectedMonth("");
      setSelectedDays("");
      setSelectedYear("");
      setIsSubmitting(false);
      localStorage.removeItem("selectedMonthsil");
      localStorage.removeItem("selectedYearsil");
      localStorage.removeItem("selectedDatesil");

      // navigate(`/book/${response.data._id}`); // Uncomment if you want to redirect
    } catch (error) {
      // 5. Handle errors
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to create book event";
      toast.error(errorMessage);
      console.error("Creation error:", error);
      setIsSubmitting(false);

      // Optional: Scroll to top to show error message
      window.scrollTo(0, 0);
    }
  };

  const handleUpdateBook = async (bookId) => {
    try {
      const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };

      const paddedMonth = monthMap[selectedMonth] ?? "01"; // Convert month name to 2-digit format
      const paddedDate = selectedDate.padStart(2, "0");
      const paddedSeconds = visibility.padStart(2, "0"); // assuming visibility is seconds
      const dateTimeStr = `${selectedYear}-${paddedMonth}-${paddedDate}T${eventTime}:${visibility}:00`; // e.g. "2025-07-11T18:00:00"
      const organizerTimeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;

      const eventTimeInOrganizerZone = fromZonedTime(
        dateTimeStr,
        organizerTimeZone
      );
      // 1. Validate and build payload
      const payload = {
        title: "",
        name: "Silent Reading",
        author: "",
        genre: "",
        // age: selectedAge,
        age: joinedAge,
        language: selectedLanguage,
        type: "In-person",
        globalTime: eventTimeInOrganizerZone.toISOString(), // accurate UTC
        timeZone: organizerTimeZone,
        description: eventDetails,
        maxAttendee: maxValue,
        minAttendee: minValue,
        userId: user?._id, // You need to get this from auth
        dateInfo: {
          day: selectedDate,
          month: selectedMonth,
          year: selectedYear,
          dayName: selectedDays,
        },
        timeTrack: {
          minutes: eventTime,
          seconds: visibility,
        },
        email: user?.email,
        // city: searchQuery?.name,
        // langi: searchQuery?.longitude,
        // lati: searchQuery?.latitude,
        city: selectedCityObj?.city, // ✅ Use from selectedCityObj
        country: selectedCityObj?.country, // ✅ Optional if needed
        lati: selectedCityObj?.latitude, // ✅ Accurate location
        langi: selectedCityObj?.longitude,
        image: "",
        ...("In-person" === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0, // ✅ longitude first
              selectedCityObj?.latitude ?? 0, // ✅ then latitude
            ],
          },
        }),
      };

      // 2. Check for any missing required fields
      const requiredFields = {
        Age: payload.age,
        Language: payload.language,
        "Event Type": payload.type,
        Description: payload.description,
        "Date (day)": payload.dateInfo.day,
        "Date (month)": payload.dateInfo.month,
        "Date (year)": payload.dateInfo.year,
        "Time (minutes)": payload.timeTrack.minutes,
        ...(payload.type === "In-person" && {
          "Location Name": payload.location?.name,
          "Location Address": payload.location?.address,
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // 3. Make API call with Axios
      const response = await axios.put(
        `/api/v1/books/updatebook/${bookId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Add if using authentication:
            // 'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
        }
      );

      // 4. Handle success
      toast.success("Book updated successfully!");
      console.log("Created book:", response.data);
      handleShow(true);
      setSelectedDate("");
      setSelectedMonth("");
      setSelectedDays("");
      setSelectedYear("");
      localStorage.removeItem("selectedMonthsil");
      localStorage.removeItem("selectedYearsil");
      localStorage.removeItem("selectedDatesil");
      setIsSubmitting(false);

      // navigate(`/book/${response.data._id}`); // Uncomment if you want to redirect
    } catch (error) {
      // 5. Handle errors
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to updated book event";
      toast.error(errorMessage);
      console.error("updated error:", error);
      setIsSubmitting(false);

      // Optional: Scroll to top to show error message
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div className="hederwbokd">
        <Header3 />
      </div>
      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Layout: Image on Left, Form on Right */}
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            {/* Book Cover - Left Side */}
            <div className="w-full max-w-[200px] mx-auto lg:mx-0 lg:w-64 flex-shrink-0">
              <div className="bg-gray-100 rounded-xl shadow-sm border border-gray-200 w-full aspect-[2/3] flex items-center justify-center overflow-hidden relative">
                <img
                  src={require("../image/book7.jpg")}
                  alt="Silent Reading"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Form Section - Right Side */}
            <div className="flex-1 bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
              {/* Badge inside form */}
              <div className="mb-6">
                <div className="inline-block px-4 py-2 bg-[#D1EBFF] rounded-lg text-dark font-semibold text-base">
                  SILENT READING
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Date Selection */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.when || "When"}
                </label>
                <div className="grid grid-cols-3 gap-2">
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedDate(e.target.value)}
                      value={selectedDate || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">{lg?.day || "Day"}</option>
                      {Array.from({ length: 31 }, (_, i) => {
                        const value = (i + 1).toString().padStart(2, "0");
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      value={selectedMonth || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">{lg?.month || "Month"}</option>
                      {availableMonths.map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedYear(e.target.value)}
                      value={selectedYear || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">{lg?.year || "Year"}</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
                {selectedDays && (
                  <div className="mt-2 px-3 py-1.5 bg-[#34C3C91a] text-[#34C3C9] rounded-lg text-sm font-medium inline-block">
                    {selectedDays}
                  </div>
                )}
              </div>

              {/* Time Selection */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.time || "Time"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={eventTime || ""}
                      onChange={(e) => setEventTime(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">{lg?.hour || "Hour"}</option>
                      {Array.from({ length: 24 }, (_, i) => {
                        const value = i.toString().padStart(2, "0");
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={visibility || ""}
                      onChange={(e) => setVisibility(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">{lg?.min || "Minute"}</option>
                      {Array.from({ length: 60 }, (_, i) => {
                        const value = i.toString().padStart(2, "0");
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>
              {/* Location Fields */}
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.where || "Where"}
                </label>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder={lg?.city || "City"}
                      value={searchQuery}
                      onChange={handleInputChangeCity}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                    />
                    {isLoading && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="spinner-border text-primary spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                    {suggestionsCity.length > 0 && (
                      <ul className="absolute w-full mt-1 max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                        {suggestionsCity.map((suggestion, index) => (
                          <li
                            key={index}
                            className="px-4 py-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 last:border-b-0 text-sm"
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion.city}, {suggestion.country}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder={lg?.venue || "Venue"}
                    value={eventLocation}
                    onChange={(e) => setEventLocation(e.target.value)}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                  />
                  <input
                    type="text"
                    placeholder={lg?.address || "Address"}
                    value={eventAddress}
                    onChange={(e) => setEventAddress(e.target.value)}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                  />
                </div>
              </div>

              {/* Age Range */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.agerg || "Age Range"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={selectedAge || ""}
                      onChange={(e) => setSelectedAge(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">Min</option>
                      {Array.from({ length: 90 - 18 + 1 }, (_, i) => {
                        const age = i + 18;
                        return (
                          <option key={age} value={age}>
                            {age}
                          </option>
                        );
                      })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={selectedMaxAge || ""}
                      onChange={(e) => setSelectedMaxAge(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">Max</option>
                      <option value="no-limit">No Limit</option>
                      {[...Array(90)]
                        .map((_, i) => i + 2)
                        .filter((val) => {
                          const minAge = parseInt(selectedAge);
                          if (isNaN(minAge)) return true;
                          return val > minAge;
                        })
                        .map((val) => (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>

              {/* Language */}
              <div>
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                  {lg?.language || "Language"}
                  <div className="relative group">
                    <BsQuestionCircleFill className="text-gray-400 cursor-help" size={14} />
                    <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                      This is the language participants are expected to use if they interact or chat during or after the Silent Reading.
                    </div>
                  </div>
                </label>
                <div className="relative">
                  <select
                    value={selectedLanguage || ""}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                    style={{ paddingRight: "2.5rem" }}
                  >
                    <option value="">{lg?.selectLanguage || "Select Language"}</option>
                    {languages.map((language) => (
                      <option key={language._id} value={language.code}>
                        {language.name}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                </div>
              </div>

              {/* Attendees */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.attendees || "Attendees"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={minValue || ""}
                      onChange={handleMinChange}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">Min</option>
                      {[...Array(49)].map((_, i) => {
                        const val = i + 2;
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={maxValue || ""}
                      onChange={handleMaxChange}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                      <option value="">Max</option>
                      <option value="no-limit">No Limit</option>
                      {[...Array(98)]
                        .map((_, i) => i + 2)
                        .filter((val) => {
                          const parsedMin = parseInt(minValue);
                          if (isNaN(parsedMin)) return true;
                          return val > parsedMin;
                        })
                        .map((val) => (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>

              {/* Details */}
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.detil || "Details"}
                </label>
                <textarea
                  required
                  value={eventDetails}
                  onChange={(e) => setEventDetails(e.target.value)}
                  rows={4}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 resize-none"
                  placeholder={lg?.eventDetails || "Enter event details..."}
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={async () => {
                  if (isSubmitting) return;
                  setIsSubmitting(true);

                  try {
                    if (id) {
                      await handleUpdateBook(id);
                    } else {
                      await handleCreateEvent();
                    }
                  } catch (err) {
                    console.error("Error during submit:", err);
                  }
                }}
                disabled={isSubmitting}
                className="px-8 py-3 bg-[#34C3C9] text-white font-semibold rounded-lg hover:bg-[#2BB3BA] transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <Spinner animation="border" size="sm" className="text-white" />
                    <span>{id ? "Updating..." : "Publishing..."}</span>
                  </>
                ) : id ? (
                  "Update"
                ) : (
                  lg?.publsbtn || "Publish"
                )}
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/*  msg */}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="customdeldetl "
      >
        <Modal.Header className=" border-0  ">
          <img
            className=" border-0 closebtn  closebokde "
            src={require("../../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 mx-4 text-dark fw-bold mb-4 mt-auto mt-sm-3 mb-sm-5 ftnotfi"
          style={{
            fontSize: "26px",
            lineHeight: "43.58px",
          }}
        >
          {lg?.silentReadingLive || "Well done! Your Silent Reading is now live and people can join it."}
        </Modal.Title>
      </Modal>

      <Modal
        show={wShow}
        onHide={handleCloseW}
        centered
        className="customseesug"
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn podclosre "
            src={require("../../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
            style={{ marginTop: "-8px" }}
          />
        </Modal.Header>
        <Modal.Title className="text-center mt-md-1 ">
          <div className="d-flex justify-content-center gap-sm-4 gap-1">
            <div
              className=" align-items-center   "
              style={{ backgroundColor: "transparent" }}
            >
              <InputGroup
                className=" outline1 outline1model"
                style={{ backgroundColor: "transparent" }}
              >
                <img
                  className=" mx-2 mt-2   mobilwid1 "
                  src={require("../../pages/image/lactionicon.png")}
                  alt="logo"
                />
                <Form.Control
                  className=" placeholder-1 fw600 fs-5  ftzinput"
                  style={{
                    backgroundColor: "transparent",

                    color: "#979797",
                  }}
                  placeholder="Amsterdam"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                />
                <InputGroup.Text
                  className="mobil155 border-0"
                  id="basic-addon2"
                  style={{
                    width: "51px",
                    height: "53px",
                    marginTop: "-2px",
                    marginRight: "-2px",
                    backgroundColor: "#34C3C9",
                    borderRadius: "0px 10px 10px 0",
                  }}
                >
                  <img
                    className=" sm:w-100  mobilwid111 "
                    src={require("../../pages/image/searchwhite.png")}
                    alt="logo"
                  />
                </InputGroup.Text>
              </InputGroup>
            </div>
            <div
              className="d-flex gap-2 mapimgwid py-2 justify-content-center rounded-3 fw600 fs-5 "
              style={{
                color: "#595959",
                border: "2px solid #34C3C9",
                width: "156px",
                height: "53px",
              }}
            >
              <a
                href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                target="_blank" // Open in new tab
                rel="noopener noreferrer" // Security feature for opening a new tab
                style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                className="d-flex gap-2"
              >
                <img
                  src={require("../../pages/image/mapmodel.png")}
                  width="30"
                  height="27"
                />
                Map
              </a>
            </div>
          </div>
        </Modal.Title>

        <Modal.Body className="mx-sm-5 mt-md-2  ppadsmmodel  ">
          <div className="fs-4 fw-bold westeast">West Amsterdam</div>
          <div className="d-flex mt-1    gap-sm-3 gap-2 ">
            <img
              className=" cevimg  "
              src={require("../../pages/image/cevtmodel.png")}
              width="330"
              height="170"
              style={{ position: "relative" }}
            />

            <div
              className="d-flex gapimagmodel mx-sm-3   align-items-center "
              style={{ position: "absolute" }}
            >
              <img
                className=" cevimgjj  "
                src={require("../../pages/image/meetupmodelimg.png")}
              />
              <img
                className=" cevimgjj  "
                src={require("../../pages/image/meetupmodelimg.png")}
                style={{ rotate: "180deg" }}
              />
            </div>
            <div>
              <div className="fw-bold mt-md-2 fs-4  westeast "> Podieum</div>
              <div
                className="fw600 allaptext  fs-6"
                style={{ color: "#474747" }}
              >
                A. Staalmanplein 12, 1089 AP <br />
                Amsterdam, NL
                <br />
                Phone: 06 46718100
                <br />
                Website:{" "}
                <Link
                  to="https://www.podieum.nl/"
                  className="text-primary text-decoration-underline"
                >
                  {" "}
                  https://www.podieum.nl/
                </Link>
                <br />
                <a
                  href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" // Security feature for opening a new tab
                  style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                >
                  See on{" "}
                  <span className="text-decoration-underline">Google Maps</span>
                </a>
              </div>
            </div>
          </div>

          <div className="d-flex mt-3 gap-sm-3 gap-2 ">
            <img
              className=" cevimg "
              src={require("../../pages/image/cevtmodel.png")}
              width="330"
              height="170"
              style={{ position: "relative" }}
            />

            <div
              className="d-flex gapimagmodel mx-sm-3   align-items-center "
              style={{ position: "absolute" }}
            >
              <img
                className=" cevimgjj  "
                src={require("../../pages/image/meetupmodelimg.png")}
              />
              <img
                className=" cevimgjj  "
                src={require("../../pages/image/meetupmodelimg.png")}
                style={{ rotate: "180deg" }}
              />
            </div>
            <div>
              <div className="fw-bold mt-md-2 fs-4  westeast "> Podieum</div>
              <div
                className="fw600 allaptext  fs-6"
                style={{ color: "#474747" }}
              >
                A. Staalmanplein 12, 1089 AP <br />
                Amsterdam, NL
                <br />
                Phone: 06 46718100
                <br />
                Website:{" "}
                <Link
                  to="https://www.podieum.nl/"
                  className="text-primary text-decoration-underline"
                >
                  {" "}
                  https://www.podieum.nl/
                </Link>
                <br />
                <a
                  href="https://www.google.com/maps/@40.69754,-74.3093378,10z?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D" // Replace with specific Google Maps location URL if needed
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" // Security feature for opening a new tab
                  style={{ textDecoration: "none", color: "inherit" }} // Preserve styles and text color
                >
                  See on{" "}
                  <span className="text-decoration-underline">Google Maps</span>
                </a>
              </div>
            </div>
          </div>

          <div className="fs-4 fw-bold westeast ">East Amsterdam</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SilentReading;
